module.exports = __webpack_public_path__ + "img/logo-grey.68231661.svg";